import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedSearchResponse } from '../interfaces/paginated-search-response';
import { SsoUserDetailsDto } from '../interfaces/sso-user-details-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class UserSearchService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/enterprise-user/enterprise';
    }

    getUsersByEnterpriseId(enterpriseId: number, searchTerm: string, page: number, itemsPerPage: number, sortBy: string, sortOrder: string,
        isEnterpriseAdmin: boolean | null = null):
    Observable<PaginatedSearchResponse<SsoUserDetailsDto>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        let params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', page)
            .set('size', itemsPerPage)
            .set('sort', sortBy + ',' + sortOrder);
        if (isEnterpriseAdmin !== null) {
            params = params.set('isEnterpriseAdmin', isEnterpriseAdmin);
        }
        return this.http.get<PaginatedSearchResponse<SsoUserDetailsDto>>(`${this.baseUrl}/${enterpriseId}`, { headers, params });
    }

    isUsernameUnique(enterpriseId: number, username: string): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/${enterpriseId}/validate-username`, {},{ params: { username: username } });
    }

    isEmailUnique(enterpriseId: number, email: string): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/${enterpriseId}/validate-email`, {}, { params: { email: email } });
    }
}
